import * as React from 'react'
import { SVGProps, Ref, forwardRef, memo } from 'react'

const SvgMail = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <g fill="currentColor" fillRule="nonzero">
      <path d="M22 3.5H2a1 1 0 0 0-1 1v15a1 1 0 0 0 1 1h20a1 1 0 0 0 1-1v-15a1 1 0 0 0-1-1Zm-1 2v13H3v-13h18Z" />
      <path d="M21.4 3.7a1 1 0 0 1 1.296 1.519L22.6 5.3l-10 7.5a1 1 0 0 1-1.09.072l-.11-.072-10-7.5a1 1 0 0 1 1.095-1.669L2.6 3.7l9.4 7.05 9.4-7.05Z" />
      <path d="M12 3.5a1 1 0 0 1 .117 1.993L12 5.5H3V12a1 1 0 0 1-.883.993L2 13a1 1 0 0 1-.993-.883L1 12V4.5a1 1 0 0 1 .883-.993L2 3.5h10Z" />
      <path d="M22 3.5a1 1 0 0 1 .993.883L23 4.5V12a1 1 0 0 1-1.993.117L21 12V5.5h-9a1 1 0 0 1-.993-.883L11 4.5a1 1 0 0 1 .883-.993L12 3.5h10Z" />
    </g>
  </svg>
)

const ForwardRef = forwardRef(SvgMail)
const Memo = memo(ForwardRef)
export default Memo
